import angular from 'angular';

import component from './venue-hours-edit-order.component';

const VenueHoursEditOrder = angular
    .module('control-room.venue-hours.components.venue-hours-edit-order', [])
    .component('crVenueHoursEditOrder', component);

export default VenueHoursEditOrder;
